import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import AdminAlumniModal from "./AdminAlumniModal";
import "../styles/AdminAlumniManager.css";

const AdminAlumniManager = () => {

  const [alumni,setAlumni] = useState([]);
  const [modalShow,setModalShow] = useState(false);
  const [editAlumni,setEditAlumni] = useState(null);
  const [search,setSearch] = useState("");

  const API = "/api/alumni";

  const fetchAlumni = async () => {
    try {
      const res = await axios.get(API);
      setAlumni(res.data);
    } catch(err){ console.log(err);}
  }

  useEffect(()=>{ fetchAlumni() },[]);

  const handleAddEdit = async(formData)=>{
    const data = new FormData();
    data.append("name",formData.name);
    data.append("year",formData.year);
    data.append("about",formData.about);
    if(formData.image) data.append("image",formData.image);

    try{
      if(editAlumni){
        await axios.put(`${API}/update/${editAlumni.id}`, data);
      } else {
        await axios.post(`${API}/add`, data);
      }
      setModalShow(false);
      setEditAlumni(null);
      fetchAlumni();
    } catch(err){console.log(err);}
  }

  const handleDelete = async(id)=>{
    if(!window.confirm("Delete this alumni?")) return;
    await axios.delete(`${API}/delete/${id}`);
    fetchAlumni();
  }

  const filteredAlumni = alumni.filter(a=>
    a.name.toLowerCase().includes(search.toLowerCase()) ||
    String(a.year).includes(search)
  );

  return (
    <div className="admin-alumni">
      <div className="header">
        <h2>Alumni Manager</h2>
        <button onClick={()=>{setEditAlumni(null); setModalShow(true)}} className="add-btn">Add Alumni</button>
      </div>

      <input
        type="text"
        placeholder="Search by name or batch..."
        className="search-input"
        value={search}
        onChange={e=>setSearch(e.target.value)}
      />

      <table className="admin-alumni-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Photo</th>
            <th>Name</th>
            <th>Batch</th>
            <th>About</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredAlumni.map(a=>(
            <tr key={a.id}>
              <td>{a.id}</td>
              <td>
                <img
                  src={`${BASE_URL}/uploads/alumni/${a.image}`}
                  alt={a.name}
                  className="admin-alumni-img"
                />
              </td>
              <td>{a.name}</td>
              <td>{a.year}</td>
              <td className="about-cell">{a.about}</td>
              <td>
                <button className="edit-btn" onClick={()=>{setEditAlumni(a); setModalShow(true)}}>Edit</button>
                <button className="delete-btn" onClick={()=>handleDelete(a.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <AdminAlumniModal
        show={modalShow}
        onClose={()=>setModalShow(false)}
        onSubmit={handleAddEdit}
        alumni={editAlumni}
      />
    </div>
  )
}

export default AdminAlumniManager;